import 'mlmi-library'
import Mobile from 'mlmi-library/modules/mobile/v1/mobile'
import { CoreDetect_WebP } from 'mlmi-library/utils/device'

export { Mobile }

CoreDetect_WebP()
